export default __webpack_public_path__ + "static/media/editIconHover.cc863023.svg";